import { createSlice } from '@reduxjs/toolkit';

const modelSlice = createSlice({
  name: 'model',
  initialState: {
    type: '',
  },
  reducers: {
    setModelType(state, { payload }) {
      const { type } = payload;
      state.type = type;
    },
  },
});

export const actions = { ...modelSlice.actions };
export default modelSlice.reducer;
